export default __webpack_public_path__ + "static/media/benefit_2@2x.fc1f4f78.png";